// removed by extract-text-webpack-plugin
module.exports = {"root":"_2b3ms","isSticky":"_3iyE-","inner":"_1kaxo"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SectionNavigation/SectionNavigation.scss
// module id = 1312
// module chunks = 3